export const OSHI_INFO_BANNER_TYPE = {
    REGULAR: 'regular',
    INFO: 'info',
};

export const OSHI_INFO_BANNER_SENTIMENT = {
    SUCCESS: 'success',
    ERROR: 'error',
};